import { ApolloLink } from '@apollo/client';
import { updateTrueTime } from './true-time';

export const apolloTrueTimeLink = new ApolloLink((operation, forward) => {
  const sentAt = Date.now();

  return forward(operation).map((result) => {
    const dateHeader: string | null | undefined = operation
      .getContext()
      .response?.headers?.get('date');

    if (dateHeader) {
      updateTrueTime(dateHeader, sentAt, Date.now());
    }

    return result;
  });
});
